module.exports = __webpack_public_path__ + "img/Group2.c5b44ed1.png";